import moment from "moment";
import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaPreguntaFacturaccion, mostrarAlertaLoading, cerrarAlerta } from "../../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import MetodosPagoDinamicos from "../../../componentes/metodos/MetodosPagos";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import { ProductosListar, VentaGuardar, VentaListar, VentaListarId } from "../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { ImprimirVenta } from "./anular/ImprimirVentas";
import { pdf } from '@react-pdf/renderer';
import ReporteVentas from "./anular/ReporteVentas";

const ModalPago = ({ Total, tipoPago, pago, setPago, resetVenta, factura, cajaId, verificarCaja, rtnFactura, beforeOpen }) => {
    const { setListaVentas, ActualizarLista, setListaProductos, listaBancos, setListaVentasFiltradas } = useContextEmpleado();
    const [efectivo, setEfectivo] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0)
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [cambio, setCambio] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [montoCredito, setMontoCredito] = useState('');
    const [fechaPago, setFechaPago] = useState(moment().format('YYYY-MM-DD'));
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const [documentoBase, setDocumentoBase] = useState(null);
    const [montosPos, setMontosPos] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});
    const esMovil = window.innerWidth <= 768;

    const [guardando, setGuardando] = useState(false);

    const buscarNumeroFactura = (lista) => {
        var n = 0;
        if (lista.length > 0) {
            lista.forEach(f => {
                n = f.numero
            })
        }
        return n;
    };

    const buscarNumeroRecibo = (lista) => {
        var n = 0;
        if (lista) {
            lista.forEach(f => {
                n = f.id
            })
        }
        return n;
    };

    const buscarNumeroCredito = (lista) => {
        var n = 0;
        if (lista) {
            lista.forEach(f => {
                n = f.id
            }
            )
        }
        return n;
    };

    const accion = (tipos, baseDoc) => {
        const numero =
            tipos === "FA"
                ? buscarNumeroFactura(pago.facturas)
                : tipos === "RE"
                    ? buscarNumeroRecibo(pago.recibos)
                    : buscarNumeroCredito(pago.creditos);

        if (baseDoc) setDocumentoBase(baseDoc);

        setPago(prev => ({
            ...prev,
            documento: tipos,
            numero,
            items: factura.items,
        }));
        setDatosPago(prev => ({
            ...prev,
            documento: tipos,
            tipoVenta: tipos === "CR" ? "Crédito" : "Contado"
        }));
        setModalIsOpen(true);
    };

    const ver = async () => {
        if (beforeOpen) {
            const continuar = await beforeOpen();
            if (continuar === false) return;
        }
        const cajaValida = await verificarCaja();
        if (!cajaValida) return;
        mostraAlertaPreguntaFacturaccion(
            (tipo, baseDoc) => {
                accion(tipo, baseDoc);
            },
            "¿Qué desea generar?"
        );
    };

    const [datosPago, setDatosPago] = useState({
        pago: Total,
        recibido: totalRecibido,
        tipo: tipoPago,
        tipoVenta: 'Contado',
        documento: 'FA',
        efectivo: [],
        transferencia: [],
        tarjeta: [],
        montoCredito: 0,
        fecha: '',
        fechaVencimiento: '',
        saldo: 0,
    });

    const totalConRecargo = pago.documento === "FA"
        ? parseFloat(pago.subtotal) + parseFloat(pago.isvTotal)
        : Total;

    useEffect(() => {
    }, [datosPago]);

    useEffect(() => {
    }, [pago]);

    useEffect(() => {
        const r = parseFloat(pos || 0) + parseFloat(transferencias || 0) + parseFloat(efectivo || 0)
        setTotalRecibido(r);
    }, [pos, transferencias, efectivo]);

    useEffect(() => {
        actualizarListaPagos();
    }, [totalRecibido, montosPos, referenciasPos, montosTransferencia, referenciasTransferencia, datosPago.documento]);

    const actualizarListaPagos = () => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto"; // Si hay mezcla, mejor indicar mixto o el método predominante
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo: parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        const listaPos = Object.keys(montosPos)
            .filter(cuentaId => parseFloat(montosPos[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosPos[cuentaId]),
                referencia: referenciasPos[cuentaId] || "",
                posId: parseInt(cuentaId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    };

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setCambio(0);
        setModalIsOpen(false);
        setMontoCredito('');
        setFechaPago(moment().format('YYYY-MM-DD'));
        setFechaVencimiento('');
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
    };

    const GuardarVentas = async () => {
        // Evita ejecuciones simultáneas si ya está guardando
        if (guardando) return;
        let hayError = false;

        const obtenerCuentasParaValidacion = (tipo) => {
            return listaBancos.flatMap(banco =>
                banco.cuenta
                    .filter(c => c.tipoCuenta === tipo && c.activo)
                    .map(c => ({
                        id: c.id,
                        digitosMinimos: tipo === 'Pos' ? 6 : 8,
                    }))
            );
        };

        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        obtenerCuentasParaValidacion('Pos').forEach(({ id, digitosMinimos }) => {
            const monto = parseFloat(montosPos[id] || 0);
            const referencia = referenciasPos[id] || "";
            const regex = new RegExp(`^\\d{${digitosMinimos},15}$`);

            if (monto > 0 && !regex.test(referencia)) {
                nuevosErroresPos[id] = true;
                hayError = true;
            }
        });
        setErroresReferenciaPos(nuevosErroresPos);

        obtenerCuentasParaValidacion('Transferencia').forEach(({ id, digitosMinimos }) => {
            const monto = parseFloat(montosTransferencia[id] || 0);
            const referencia = referenciasTransferencia[id] || "";
            const regex = new RegExp(`^\\d{${digitosMinimos},15}$`);

            if (monto > 0 && !regex.test(referencia)) {
                nuevosErroresTransferencia[id] = true;
                hayError = true;
            }
        });
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);

        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación"); 
            //cerrarAlerta();
            return;
        }

        const esCredito = datosPago.tipoVenta === 'Crédito';

        if (!esCredito) {
            const totalNum = parseFloat(Total);
            const efectivoNum = parseFloat(efectivo || 0);
            const posNum = parseFloat(pos || 0);
            const transferenciaNum = parseFloat(transferencias || 0);
            const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;

            if (totalRecibidoNum <= 0) {
                mostraAlertaError("Debe ingresar al menos un método de pago.", "Error");
                //cerrarAlerta();
                return;
            }

            if (efectivoNum === 0 && totalRecibidoNum !== totalNum) {
                mostraAlertaError("Cuando no hay pago en efectivo, el total de tarjeta y transferencias debe coincidir exactamente con el total de la venta.", "Pago inválido");
                //cerrarAlerta();
                return;
            }

            if (efectivoNum > 0) {
                if ((posNum + transferenciaNum) > totalNum) {
                    mostraAlertaError("La suma de tarjeta y transferencias no puede exceder el total de la venta cuando se paga con efectivo.", "Pago inválido");
                    //cerrarAlerta();
                    return;
                }

                const restante = totalNum - (posNum + transferenciaNum);
                if (efectivoNum < restante) {
                    mostraAlertaError("El efectivo ingresado es insuficiente para cubrir el restante de la venta.", "Pago inválido");
                    //cerrarAlerta();
                    return;
                }
            }

            if (totalRecibidoNum < totalNum) {
                mostraAlertaError("El total recibido no puede ser menor al total a pagar.", "Error");
                //cerrarAlerta();
                return;
            }
        }
        // Bloqueamos ejecuciones adicionales
        setGuardando(true);
        mostrarAlertaLoading("Guardando venta...", "Espere por favor");
        
        const cambioCalculado = esCredito ? 0 : totalRecibido - Total;
        setPago(prev => ({
            ...prev,
            cambio: cambioCalculado,
        }));

        let facturaPayload = null;
        let reciboPayload = null;

        const docTipo = datosPago.documento;

        const isFactura = docTipo === 'FA' || (docTipo === 'CR' && documentoBase === 'FACTURA');
        const isRecibo = docTipo === 'RE' || (docTipo === 'CR' && documentoBase === 'RECIBO');

        if (isFactura) {
            facturaPayload = {
                numeroFactura: 1,
                fecha: moment().toISOString(),
                estado: "Completada",
                tipoPago: datosPago.tipo,
                total: Total || 0,
            };
        } else if (isRecibo) {
            reciboPayload = {
                fecha: moment().toISOString(),
                estado: 'Completada',
                tipoPago: datosPago.tipo,
                total: Total,
            };
        }

        const payload = {
            venta: {
                numeroFactura: 1,
                tipoPago: datosPago.tipo,
                tipoVenta: datosPago.tipoVenta,
                descuento: parseFloat(pago.descuentoAplicado) || 0,
                descuentoTercera: 0,
                cajaId: cajaId,
                estado: "Completada",
                subtotal: parseFloat(pago.subtotal) || 0,
                totalVenta: pago.total || totalConRecargo,
                exento: pago.importeExento || 0,
                importeImpuesto15: pago.importe15 || 0,
                importeImpuesto18: pago.importe18 || 0,
                impuesto15: pago.isv15 || 0,
                impuesto18: pago.isv18 || 0,
                exonerado: 0,
                transferencia: 0,
                empleadoId: pago.empleadoId || 0,
                clienteId: pago.clienteId || 0,
                rtn: rtnFactura,
                ventaPedidos: pago.pedidos.map(p => ({ pedidoId: p.id })),
                ventaDetallePedidos: pago.items
                    .filter(i => i.tipo === "Producto")
                    .map(i => {
                        const subtotalSinImpuesto = i.precioConImpuesto * i.cantidad;
                        const subtotalSoloImpuesto = i.isvSinImpuesto * i.cantidad;

                        return {
                            cantidad: i.cantidad,
                            precio: i.precioConImpuesto,
                            itemId: i.id,
                            loteId: i.loteId,
                            loteInventarioId: i.loteInventarioId,
                            precioOriginal: i.precioOriginalConImpuesto,
                            impuesto: i.isvSinImpuesto,
                            tipoImpuesto: i.impuesto,
                            subtotal: parseFloat(subtotalSinImpuesto.toFixed(2)),
                            subtotalImpuesto: parseFloat(subtotalSoloImpuesto.toFixed(2)),
                            descuento: parseFloat(i.descuentoAplicado.toFixed(2)) || 0,
                        };
                    }),
            },
            pago: {
                fecha: moment().toISOString(),
                pago: Total,
                estado: "Completada",
                recibido: esCredito ? 0 : totalRecibido,
                documento: datosPago.documento,
                cajaId: cajaId,
                efectivo: datosPago.efectivo || [],
                transferencia: datosPago.transferencia || [],
                tarjeta: datosPago.tarjeta || [],
            },
            factura: facturaPayload,
            recibo: reciboPayload,

            credito: {
                monto: datosPago.montoCredito || Total,
                fecha: moment().toISOString(),
                estado: "Pendiente",
                fechaVencimiento: datosPago.fechaVencimiento,
                saldo: datosPago.saldo || 0,
            }
        };

        try {
            const response = await AxiosPublico.post(VentaGuardar, payload);
            cerrarAlerta();
            if (response.status === 200 || response.status === 201) {
                mostraAlertaOk("Venta guardada exitosamente", "Éxito");
                const ventaCompleta = response.data;
                if (esMovil)
                    ImprimirVenta(ventaCompleta);
                else {
                    const blob = await pdf(<ReporteVentas venta={ventaCompleta} />).toBlob();
                    const url = URL.createObjectURL(blob);

                    // Abrir en nueva pestaña
                    window.open(url, "_blank");
                }
                /*const ventaId = response.data.id;
                try {
                    const ventaCompleta = await AxiosPublico.get(`${VentaListarId}?id=${ventaId}`);
                    if (ventaCompleta.status === 200) {
                        ImprimirVenta(ventaCompleta.data);
                    } else {
                        console.error("Error al obtener datos completos de la venta.");
                    }
                } catch (Error) {
                    console.error("Error en la llamada para obtener los datos de la venta:", Error);
                }*/
                //ActualizarLista(VentaListar, setListaVentas);
                ActualizarLista(ProductosListar, setListaProductos);
                limpiarDatosPago();
                setModalIsOpen(false);
                setTimeout(() => {
                    resetVenta();
                }, 1000);
            }
        } catch (error) {
            const { response } = error;
            cerrarAlerta();
            if (response && Array.isArray(response.data)) {
                const mensajesError = [...new Set(response.data.map(err => err.msg))].join("\n");
                mostraAlertaError(mensajesError, "Error");
            } else {
                const msjError =
                    response?.data?.msj ||
                    response?.data?.error?.message ||
                    "Error al registrar el pago";
                mostraAlertaError(msjError, "Error");
            }
        }
        finally {
            // Habilitar nuevamente en caso de que termine o falle la transacción
            setGuardando(false);
        }
    };

    return (
        <ModalBootstrap
            nombreBoton={formatoMoneda(totalConRecargo) + "  "}
            estiloBoton={"btn btn-info"}
            modalIsOpen={modalIsOpen}
            onTriggerClick={ver}
            size={"lg"}
            setModalIsOpen={setModalIsOpen}
            titulo={`Pagos ${pago.documento === 'FA' ? 'Factura' : pago.documento === 'CR' ? 'Crédito' : 'Recibo'} ${formatoMoneda(totalConRecargo)}`}
            pie={
                <button
                    className="btn btn-primary mx-2"
                    onClick={() => {
                        if (guardando) return;
                        setPago(prev => ({ ...prev, cambio, total: totalConRecargo }));
                        GuardarVentas();
                    }}
                >
                    {guardando ? "Procesando..." : "Pagar"}
                </button>
            }>
            {pago.documento === 'CR' ? (
                <div className="p-4">
                    <h5 className="mb-4 text-center">Esta venta se registrará a crédito</h5>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="fechaPago" className="form-label">Fecha de pago:</label>
                            <input
                                id="fechaPago"
                                type="date"
                                className="form-control"
                                value={fechaPago}
                                onChange={e => setFechaPago(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="fechaVencimiento" className="form-label">Fecha de vencimiento:</label>
                            <input
                                id="fechaVencimiento"
                                type="date"
                                className="form-control"
                                value={fechaVencimiento}
                                onChange={e => {
                                    const valor = e.target.value;
                                    setFechaVencimiento(valor);
                                    setDatosPago(prev => ({
                                        ...prev,
                                        fechaVencimiento: valor
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <MetodosPagoDinamicos
                    efectivo={efectivo}
                    setEfectivo={setEfectivo}
                    montosPos={montosPos}
                    setMontosPos={setMontosPos}
                    referenciasPos={referenciasPos}
                    setReferenciasPos={setReferenciasPos}
                    erroresReferenciaPos={erroresReferenciaPos}
                    setErroresReferenciaPos={setErroresReferenciaPos}
                    montosTransferencia={montosTransferencia}
                    setMontosTransferencia={setMontosTransferencia}
                    referenciasTransferencia={referenciasTransferencia}
                    setReferenciasTransferencia={setReferenciasTransferencia}
                    erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                    setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                    pos={pos}
                    setPos={setPos}
                    transferencias={transferencias}
                    setTransferencias={setTransferencias}
                    formatoMoneda={formatoMoneda}
                    totalConRecargo={totalConRecargo}
                    totalRecibido={totalRecibido}
                />
            )}
        </ModalBootstrap>
    );
}
export default ModalPago;